/**
 * Announcement bar slider
 * - Auto-rotates slides with a fade (interval + fade speed set in the theme editor)
 * - Drag with the mouse (desktop) or swipe with a finger (mobile) to go next/prev
 * - Pauses while hovering or dragging; respects prefers-reduced-motion for autoplay
 * No dependencies.
 */
(function () {
  var DRAG_THRESHOLD = 40; // px the pointer must travel to change slide
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function AnnouncementSlider(el) {
    this.el = el;
    this.slides = Array.prototype.slice.call(
      el.querySelectorAll('.announcement_slide')
    );
    if (this.slides.length < 2) return;

    this.index = 0;
    this.speed = (parseFloat(el.dataset.speed) || 3) * 1000; // ms per slide
    this.autoplay = el.dataset.autoplay !== 'false' && !reduceMotion;
    this.timer = null;

    this.slides[this.index].classList.add('is-active');
    this._bindDrag();

    // Pause auto-rotate while the pointer is over the bar
    el.addEventListener('mouseenter', this.stop.bind(this));
    el.addEventListener('mouseleave', this._resume.bind(this));

    // Pause when the tab is hidden to save cycles
    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.hidden) this.stop();
        else this._resume();
      }.bind(this)
    );

    if (this.autoplay) this.start();
  }

  AnnouncementSlider.prototype.go = function (i) {
    var count = this.slides.length;
    this.slides[this.index].classList.remove('is-active');
    this.index = ((i % count) + count) % count;
    this.slides[this.index].classList.add('is-active');
  };

  AnnouncementSlider.prototype.next = function () {
    this.go(this.index + 1);
  };

  AnnouncementSlider.prototype.prev = function () {
    this.go(this.index - 1);
  };

  AnnouncementSlider.prototype.start = function () {
    this.stop();
    this.timer = setInterval(this.next.bind(this), this.speed);
  };

  AnnouncementSlider.prototype.stop = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  AnnouncementSlider.prototype._resume = function () {
    if (this.autoplay) this.start();
  };

  AnnouncementSlider.prototype._bindDrag = function () {
    var self = this;
    var startX = 0;
    var dragging = false;
    var moved = false;

    function activeSlide() {
      return self.slides[self.index];
    }

    function onDown(e) {
      dragging = true;
      moved = false;
      startX = e.clientX;
      self.stop();
      self.el.classList.add('is-dragging');
      // Capture the pointer so we keep getting moves outside the element
      if (self.el.setPointerCapture && e.pointerId != null) {
        try {
          self.el.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
    }

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      // Follow the pointer with a little resistance for a tactile feel
      activeSlide().style.transform = 'translateX(' + dx * 0.4 + 'px)';
    }

    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      self.el.classList.remove('is-dragging');
      var dx = e.clientX - startX;
      activeSlide().style.transform = '';

      if (Math.abs(dx) > DRAG_THRESHOLD) {
        if (dx < 0) self.next();
        else self.prev();
      }
      self._resume();
    }

    // Prevent a drag from also triggering a link click
    self.el.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    });

    // Pointer Events cover mouse, touch, and pen with one code path
    self.el.addEventListener('pointerdown', onDown);
    self.el.addEventListener('pointermove', onMove);
    self.el.addEventListener('pointerup', onUp);
    self.el.addEventListener('pointercancel', onUp);
  };

  function init() {
    var bars = document.querySelectorAll('.announcement_Text_tst.is-sliding');
    Array.prototype.forEach.call(bars, function (el) {
      if (el.dataset.annInit) return;
      el.dataset.annInit = 'true';
      new AnnouncementSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init inside the Shopify theme editor when the section reloads
  document.addEventListener('shopify:section:load', init);
})();
